var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBtnCheckboxWarn = function SvgBtnCheckboxWarn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C5.2 0.5 0.5 5.2 0.5 11C0.5 16.8 5.2 21.5 11 21.5C16.8 21.5 21.5 16.8 21.5 11C21.5 5.2 16.8 0.5 11 0.5ZM11 20C6.04 20 2 15.96 2 11C2 6.04 6.04 2 11 2C15.96 2 20 6.04 20 11C20 15.96 15.96 20 11 20Z",
    fill: "#ED1313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4299 6.17029C15.0599 5.93029 14.5599 6.04029 14.3199 6.41029L9.63988 13.7003C9.58988 13.7803 9.46988 13.7903 9.40988 13.7103L7.03988 10.8203C6.75988 10.4803 6.25988 10.4303 5.90988 10.7103C5.57988 11.0003 5.52988 11.5003 5.80988 11.8403L8.99988 15.7403C9.14988 15.9303 9.37988 16.0303 9.61988 16.0303C9.63988 16.0303 9.64988 16.0303 9.66988 16.0303C9.92988 16.0103 10.1599 15.8803 10.2999 15.6603L15.6799 7.28029C15.9099 6.91029 15.7999 6.41029 15.4299 6.17029Z",
    fill: "#ED1313"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnCheckboxWarn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/btn_checkbox_warn.dff4bcbd.svg";
export { ForwardRef as ReactComponent };